import { generateSchedule } from '@/api_client/open_ai';
import useBusinessHours from '@/hooks/useBusinessHours';
import { QK_EVENT_TYPES } from '@/queries/eventTypes.queries';
import IEventType from '@/types/IEventType';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

interface ISectionScheduleProps {
	service: IEventType;
	onChange: (service: Partial<IEventType>) => void;
}
export default function useSectionSchedule(props: ISectionScheduleProps) {
	const isLoading = useIsFetching([QK_EVENT_TYPES]) > 0;
	const isMutating = useIsMutating([QK_EVENT_TYPES]) > 0;
	const { t } = useTranslation();

	const aiForm = useForm({
		defaultValues: {
			userInput: '',
		},
	});

	const businessHours = useBusinessHours({
		businessHours: props.service.repeatingAvailability,
		onChange: (businessHours) => {
			props.onChange({ repeatingAvailability: businessHours });
		},
	});

	const handleGenerateAIScheduleClick = aiForm.handleSubmit(async (data) => {
		return generateSchedule({
			businessHours: props.service.repeatingAvailability,
			userInput: data.userInput,
		})
			.then((weekly) => {
				return props.onChange({ repeatingAvailability: { ...props.service.repeatingAvailability, weekly } });
			})
			.catch((err) => {
				return toast.error(t('We cannot autogenerate the schedule. Try a different sentence.') as string);
			});
	});

	return {
		t,
		handleGenerateAIScheduleClick,
		aiForm,
		isLoading: isLoading || isMutating,
		businessHours,
	};
}
